// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"934b008e","453":"fd0f8c1d","693":"edf05d5d","861":"49e160b6"}[chunkId] + ".chunk.js";
};